<div class="backdrop"></div>
<div class="waves-container">
  <div class="waves"></div>
  @if (loaderService.message(); as loaderMessage) {
    <div class="message">{{ loaderMessage }}</div>
  }
  @if (loaderProgressService.progress(); as progress) {
    <div class="progress">
      <mat-progress-bar mode="determinate" [value]="progress.loaded | toProgressPercentage : progress.total"></mat-progress-bar>
      <span>{{ progress.loaded | bytesToMb }}MB</span>
      <span> / </span>
      <span>{{ progress.total | bytesToMb }}MB</span>
    </div>
  }
</div>
